import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";

const DetailCard = (props) => {
  return (
    <Card
      className="shadow border-0"
      style={{ margin: "2%", position: "relative" }}
    >
      <CardHeader className="bg-primary text-white d-flex justify-content-between align-items-center">
        <h1 className="font-weight-semibold mb-0">Call Details</h1>
        <button
          onClick={props.onClose}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "2rem",
            color: "#ff4081",
            cursor: "pointer",
            lineHeight: "1",
          }}
          aria-label="Close"
        >
          &times;
        </button>
      </CardHeader>
      <CardBody>
        <CardText>
          <Row>
            <Col>
              <h3 className="font-weight-semibold">Name</h3>
              <h4 style={{ color: "#757575" }}>
                {props.rowFirstName} {props.rowLastName}
              </h4>
            </Col>
            <Col>
              <h2 className="font-weight-semibold">Phone</h2>
              <h4 style={{ color: "#757575" }}>{props.rowPhone}</h4>
            </Col>
          </Row>

          <hr
            className="rounded"
            style={{ borderTop: "8px solid #7bfd8e", borderRadius: "5px" }}
          />
          <Row>
            <Col>
              {props.rowPhone2 && (
                <>
                  <h2 className="font-weight-semibold">Phone 2</h2>
                  <h4 style={{ color: "#757575" }}>{props.rowPhone2}</h4>
                  <br />
                </>
              )}
              <h2 className="font-weight-semibold">Reference No.</h2>
              <h4 style={{ color: "#757575" }}>
                {props.referenceNumber || "---"}
              </h4>
              <br />

              <h2 className="font-weight-semibold">Added Date/Time</h2>
              <h4 style={{ color: "#757575" }}>
                {props.rowTime} on{" "}
                {moment(props.rowDate).format("Do MMM YYYY, dddd")}
              </h4>
              <br />

              {props.messageType && (
                <>
                  <h2 className="font-weight-semibold">Call Type</h2>
                  <h4 style={{ color: "#757575" }}>{props.messageType}</h4>
                  <br />
                </>
              )}

              {props.franchiseeName && (
                <>
                  <h2 className="font-weight-semibold">Franchisee Name</h2>
                  <h4 style={{ color: "#757575" }}>{props.franchiseeName}</h4>
                  <br />
                </>
              )}

              {props.messageType === "service_required" && (
                <>
                  <>
                    <h2 className="font-weight-semibold">Referred By</h2>
                    <h4 style={{ color: "#757575" }}>
                      {props.referredby === "" ? (
                        "---"
                      ) : (
                        <span>{props.referredby}</span>
                      )}
                    </h4>
                    <br />
                  </>
                  {props.referredby === "Other" && props.leadNotes && (
                    <>
                      <h2 className="font-weight-semibold">Additional Note</h2>
                      <h4 style={{ color: "#757575" }}>
                        {props.leadNotes === "" ? (
                          "---"
                        ) : (
                          <span>{props.leadNotes}</span>
                        )}
                      </h4>
                      <br />
                    </>
                  )}
                </>
              )}

              {props.messageType === "cancel_booking" && (
                <>
                  <h2 className="font-weight-semibold">Re-scheduled</h2>
                  <h4 style={{ color: "#757575" }}>
                    <span>{props.reschedule === "0" ? "No" : "Yes"}</span>
                  </h4>
                </>
              )}

              {props.notes && (
                <>
                  <h2 className="font-weight-semibold">
                    {props.messageType === "service_required"
                      ? "Comment Text"
                      : "Notes"}
                  </h2>
                  <h4 style={{ color: "#757575" }}>
                    {props.notes === "" ? "---" : <span>{props.notes}</span>}
                  </h4>
                  <br />
                </>
              )}

              {props.commentText && (
                <>
                  <h2 className="font-weight-semibold">Comment</h2>
                  <h4 style={{ color: "#757575" }}>
                    {props.commentText === "" ? (
                      "---"
                    ) : (
                      <span>{props.commentText}</span>
                    )}
                  </h4>
                </>
              )}
            </Col>
            <Col>
              {props.organization && (
                <>
                  <h2 className="font-weight-semibold">Organization</h2>
                  <h4 style={{ color: "#757575" }}>
                    {props.organization === "1"
                      ? "Blue Wheelers"
                      : "Dash/Dash Dog"}
                  </h4>
                  <br />
                </>
              )}
              {props.callScenario && (
                <>
                  <h2 className="font-weight-semibold">Call Scenario</h2>
                  <h4 style={{ color: "#757575" }}>{props.callScenario}</h4>
                  <br />
                </>
              )}
              {props.interestedService && (
                <>
                  <h2 className="font-weight-semibold">Interested Service</h2>
                  <h4 style={{ color: "#757575" }}>
                    {props.interestedService || "---"}
                  </h4>
                  <br />
                </>
              )}

              <h2 className="font-weight-semibold">Address</h2>
              <h4 style={{ color: "#757575" }}>{props.rowAddress}</h4>
              <br />
              {props.postCode && (
                <>
                  <h2 className="font-weight-semibold">Post Code</h2>
                  <h4 style={{ color: "#757575" }}>
                    {props.postCode || "---"}
                  </h4>
                  <br />
                </>
              )}
              <h2 className="font-weight-semibold">Suburb</h2>
              <h4 style={{ color: "#757575" }}>{props.rowSuburb}</h4>
              <br />
              <h2 className="font-weight-semibold">Added By</h2>
              <h4 style={{ color: "#757575" }}>
                {props.addedBy === "" ? "---" : <span>{props.addedBy}</span>}
              </h4>
            </Col>
          </Row>
        </CardText>
      </CardBody>
      <CardFooter />
    </Card>
  );
};

export default DetailCard;
